import { apiKeyClient } from "@better-auth/api-key/client";
import { adminClient, oneTimeTokenClient, organizationClient } from "better-auth/client/plugins";

import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
    baseURL: import.meta.env.VITE_AUTH_BASE_URL || "https://dummy", // The base URL of your auth server
    plugins: [organizationClient(), apiKeyClient(), oneTimeTokenClient(), adminClient()],
    fetchOptions: {
        credentials: "include",
    },
});

// A user is a super admin when their Better Auth admin-plugin role contains
// "admin". Roles are stored as a comma-separated string.
export const isAdminRole = (role?: string | null): boolean =>
    !!role &&
    role
        .split(",")
        .map((r) => r.trim())
        .includes("admin");
